var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurchaseInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6665 5.50065V7.71898C20.6665 9.16732 19.7498 10.084 18.3015 10.084H15.1665V3.67648C15.1665 2.65898 16.0007 1.83398 17.0182 1.83398C18.0173 1.84315 18.934 2.24648 19.594 2.90648C20.254 3.57565 20.6665 4.49232 20.6665 5.50065Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3335 6.41732V19.2507C2.3335 20.0115 3.19516 20.4423 3.80016 19.984L5.36766 18.8106C5.73433 18.5356 6.24766 18.5723 6.57766 18.9023L8.09933 20.4332C8.45683 20.7907 9.0435 20.7907 9.401 20.4332L10.941 18.8932C11.2618 18.5723 11.7752 18.5356 12.1327 18.8106L13.7002 19.984C14.3052 20.4332 15.1668 20.0023 15.1668 19.2507V3.66732C15.1668 2.65898 15.9918 1.83398 17.0002 1.83398H6.91683H6.00016C3.25016 1.83398 2.3335 3.47482 2.3335 5.50065V6.41732Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 11.9258H11.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 8.25977H11.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99609 11.916H6.00433",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99609 8.25H6.00433",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseInvoice);
export default __webpack_public_path__ + "static/media/purchase-invoice.28074b880109ce0d036aaf0006614eeb.svg";
export { ForwardRef as ReactComponent };